<template>
    <div className="min-h-[540px] w-full p-[6px] text-black">
        <div class="flex justify-between font-light">
            <h2>Veuillez choisir le modèle de document souhaité</h2>
            <span>{{ files.length }} documents</span>
        </div>
        <div class="mt-[22px] grid grid-cols-5 gap-10">

            <!-- <div v-on:click="showDocPage('attestation-depart-conge-maternite')" class="h-[290px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/doc1.png" alt="document 1" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">Attestation de depart en conges maternité</p>
                </div>
            </div> -->

            <!-- <div v-on:click="showDocPage('attestation-stage')" class="h-[290px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/stage.png" alt="document 1" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">Attestation de stage</p>
                </div>
            </div> -->

            <!-- <div v-on:click="showDocPage('attestation-travail')" class="h-[290px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/travail.png" alt="document 1" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">Attestation de travail</p>
                </div>
            </div> -->

            <!-- <div v-on:click="showDocPage('demande-conge')" class="h-[290px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/conge.png" alt="document 1" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">Formulaire de demande de congé</p>
                </div>
            </div> -->

            <!-- <div class="h-[290px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/affect.png" alt="document 1" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">Ordre d'affectation</p>
                </div>
            </div> -->

            <div v-for="(file,idx) in files" :key="idx" v-on:click="showDocPage(file.name)" class="h-[285px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img src="./../../assets/logo.webp" :alt="file.name" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t p-4">
                    <p class="font-extralight">{{ file.title }}</p>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import toast from "../ui/toast";
import API from "@/service/API.js";
export default {
    name:"NewDoc",
    components:{
    },
    data(){
        return {
            asSend:false,
            documentType:null,
            description:"",
            typeDoc:[],
            files:[
                {
                    name: "attest-conge",
                    img: require("./../../assets/uigb/attest_conge.png"),
                    title: "Attestation de départ en congé"
                },
                {
                    name: "attest-consultant",
                    img: require("./../../assets/uigb/attest_consultant.png"),
                    title: "Attestation de consultant"
                },
                {
                    name: "attest-travail-uigb",
                    img: require("./../../assets/uigb/attest_travail.png"),
                    title: "Attestation de travail"
                },
                {
                    name: "certificat-travail",
                    img: require("./../../assets/uigb/certificat_travail.png"),
                    title: "Certificat de travail"
                },
                {
                    name: "consultant-absence-not",
                    img: require("./../../assets/uigb/consultant_absence_not.png"),
                    title: "Consultant absence notification"
                },
                {
                    name: "domiciliation-salaire",
                    img: require("./../../assets/uigb/domiciliation_salaire.png"),
                    title: "Domiciliation salaire"
                },
                {
                    name: "employe-certificat",
                    img: require("./../../assets/uigb/employe_certificat.png"),
                    title: "Employe certificat"
                },
                {
                    name: "leave-certificate",
                    img: require("./../../assets/uigb/leave_certificate.png"),
                    title: "Leave certificate"
                },
                {
                    name: "notif-fin-contrat",
                    img: require("./../../assets/uigb/notif_fin_contrat.png"),
                    title: "Notification de fin de contrat"
                },
                {
                    name: "request-for-cert",
                    img: require("./../../assets/uigb/request_for_cert.png"),
                    title: "Request for certificat"
                },
                {
                    name: "resumption-from-leave",
                    img: require("./../../assets/uigb/resumption_from_leave.png"),
                    title: "Resumption from leave"
                },
                {
                    name: "salary-certificat",
                    img: require("./../../assets/uigb/salary_certificat.png"),
                    title: "Salary certificat"
                },
                {
                    name: "travel-auth",
                    img: require("./../../assets/uigb/travel_auth.png"),
                    title: "Travel authorization"
                }
            ]
        }
    },
    mounted(){
        //this.getAllDocumentType()
    },
    methods:{
        selectDoc(desc){
            this.desciption = desc;
        },
        getAllDocumentType(){
            API.get("/documents")
            .then((data)=>{
                this.typeDoc = data.data["data"];
            })
            .catch(e=>{console.log(e)})
        },
        submitForm(){
            this.asSend = true;
            const formData = new FormData();
            formData.append("user_id",localStorage.getItem("userId") ?? this.$store.getters.userId);
            formData.append("doc_id",this.documentType);
            API.post("user-docs",formData)
            .then((response)=>{
                if(response.data["status"]){
                    toast.success("Succes","Votre demande à été pris en compte et est en cours de traitement",3000)
                }else{
                    toast.error("Echèc",response.data["message"],5000)
                }
            })
            .catch(()=>{
                console.log("erreur sur serveur!!!!!")
            })
            .finally(()=>{
                this.asSend = false;
            })
        },
        showDocPage(name){
            this.$router.push({name})
        }
    }
}
</script>